import { SaveParams } from '@ai/api/index.type'
import { playTurboNextHostList } from '@/config/host'
import { NODE_ENV } from '@com/config/env'

export function resolveAiId(id: SaveParams['id']): string {
  return `ai_${id}`
}

export function open(id: SaveParams['id']): void {
  const _id = resolveAiId(id)

  window.open(`${process.env.AI}#/?id=${id}`, _id)
}

export function resolveAiBannerId(id: SaveParams['id']): string {
  return `ai_banner_${id}`
}

export function openAiBanner(id: SaveParams['id']): void {
  const _id = resolveAiBannerId(id)

  window.open(`${process.env.AI_BANNER}?id=${id}`, _id)
}

export function getImageToVideoRedirectUrl(): string {
  return `${playTurboNextHostList[NODE_ENV]}/#/nl/image2video`
}

export function getAvatarToVideoRedirectUrl(): string {
  return `${playTurboNextHostList[NODE_ENV]}/#/nl/avatar2video`
}
